import React from 'react';

import { SVGComponentProps } from './svg.types';

const TemplateStoreNewSVG = ({
  size = '1em',
  stroke = 'currentColor',
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <path
        stroke={stroke}
        d="M13.89 2.8799L9.19999 2.1399C5.28999 1.5299 3.47999 2.8499 2.85999 6.7599L2.11999 11.4499C1.71999 14.0099 2.13999 15.6699 3.58999 16.6799C4.34999 17.2199 5.38999 17.5799 6.73999 17.7899L11.43 18.5299C15.34 19.1399 17.15 17.8199 17.77 13.9099L18.5 9.2199C18.62 8.4499 18.67 7.7599 18.63 7.1499C18.5 4.6499 17.03 3.3699 13.89 2.8799ZM8.23999 9.3499C7.06999 9.3499 6.11999 8.3999 6.11999 7.2399C6.11999 6.0699 7.06999 5.1199 8.23999 5.1199C9.39999 5.1199 10.35 6.0699 10.35 7.2399C10.35 8.3999 9.39999 9.3499 8.23999 9.3499Z"
        fill="#878A92"
      />
      <path
        stroke={stroke}
        d="M20.5001 13.4701L19.0001 17.9801C17.7501 21.7401 15.7501 22.7401 11.9901 21.4901L7.48014 19.9901C6.07014 19.5201 5.05014 18.9401 4.39014 18.2101C5.02014 18.4601 5.75014 18.6501 6.58014 18.7801L11.2801 19.5201C11.9201 19.6201 12.5201 19.6701 13.0801 19.6701C16.3801 19.6701 18.1501 17.8901 18.7601 14.0601L19.4901 9.37006C19.5901 8.79006 19.6301 8.28006 19.6301 7.81006C21.1501 9.06006 21.3701 10.8401 20.5001 13.4701Z"
        fill="#878A92"
      />
    </svg>
  );
};

export default TemplateStoreNewSVG;
